import { useState } from 'react';

import { httpClient } from '@teachur/http-client';

import { getErrorMessage } from '@new/lib/getErrorMessage';

interface FileUploadResponse {
  id: number;
}

export const useUploadFile = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const uploadFileWithResult = async (
    file: File
  ): Promise<{ id: number | null; error: string | null }> => {
    setIsLoading(true);
    setError(null);
    try {
      const formData = new FormData();
      formData.append('file', file);
      const response = await httpClient.post<FileUploadResponse>('/files', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return { id: response.data.id, error: null };
    } catch (err) {
      const message = getErrorMessage(err, 'File upload failed');
      setError(message);
      return { id: null, error: message };
    } finally {
      setIsLoading(false);
    }
  };

  const uploadFile = async (file: File): Promise<number | null> =>
    (await uploadFileWithResult(file)).id;

  const resetError = () => setError(null);

  return { uploadFile, uploadFileWithResult, isLoading, error, resetError };
};
